import { render, staticRenderFns } from "./ListReligionPage.vue?vue&type=template&id=4147e5fe&"
import script from "./ListReligionPage.vue?vue&type=script&lang=js&"
export * from "./ListReligionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports